import { CommonModule } from '@angular/common';
import { Component, inject, NgModule, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { environment, companyList } from '../environments/support-environment';
import { appPages, routes } from './app.routes';
import { jkGlb, LazyLoadingService, OrmService, PerformanceMonitorService } from 'jk-service';
import { sysPages } from 'sys';
import { mtrPages } from 'mtr';
import { utyPages } from 'uty';
import { HttpClient } from '@angular/common/http';

import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';
ModuleRegistry.registerModules([AllCommunityModule]);

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, CommonModule],
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './app.component.css',
})
export class AppComponent {
  orm: OrmService = inject(OrmService);
  constructor(
    public http: HttpClient,
    private lazyLoadingService: LazyLoadingService,
    private performanceMonitor: PerformanceMonitorService
  ) {
    this.appInit();
  }
  ngOnInit() {
    this.preloadCriticalModules();
  }

  appInit() {
    appPages.unshift(...sysPages);
    appPages.unshift(...mtrPages);
    appPages.unshift(...utyPages);
    jkGlb.init(false, environment as any, companyList, appPages, this.orm);
  }
  private async preloadCriticalModules(): Promise<void> {
    try {
      await this.lazyLoadingService.preloadAllModules();
    } catch (error) {
      console.error('Error preloading critical modules:', error);
    }
  }
}

@NgModule({
  declarations: [],
  imports: [CommonModule, AppComponent, RouterOutlet],
  providers: [],
  exports: [],
})
export class AppModule { }
